<template>
  <div>
    <div v-if="!this.promotions" class="d-flex justify-content-center">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else class="promotionsList">
      <div v-if="promotions">
        <h2>Kody promocyjne użytkownika</h2>
        <table
          class="table "
          v-if="this.promotions && this.promotions.length > 0"
        >
          <thead>
            <tr class="tr-table">
              <th scope="col">Data przypisania do konta</th>
              <th scope="col">Wartość</th>
              <th scope="col">Kod</th>
              <th scope="col">Data ważności</th>
              <th scope="col">ID zamówienia do którego został wykorzystany</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody v-if="isFuture">
            <tr
              v-for="promotion in promotions"
              :key="promotion.id"
              :style="
                promotion.isActive &&
                isFuture(promotion.promotional_code.expiration_date)
                  ? 'background:  #ccffdd'
                  : 'background: #ffe6e6'
              "
            >
              <td>
                {{
                  promotion.creationDate
                    ? formattedDate(promotion.creationDate)
                    : ""
                }}
              </td>
              <td>
                {{
                  promotion.promotional_code.type === "WALLET_MONEY"
                    ? `${promotion.promotional_code.value} zł`
                    : `${parseFloat(
                        promotion.promotional_code.value * 100
                      ).toFixed(0)}%`
                }}
              </td>

              <td>{{ promotion.promotional_code.code }}</td>
              <td>
                {{
                  promotion.promotional_code.expiration_date
                    ? formattedDate(promotion.promotional_code.expiration_date)
                    : ""
                }}
              </td>
              <td>
                {{
                  promotion.order && !promotion.isActive
                    ? promotion.order.id
                    : "Brak"
                }}
              </td>
              <td>
                <button
                  v-if="promotion.isActive"
                  @click="startDeletingProcess(promotion)"
                  class="form-item btn btn-outline-dark"
                >
                  Usuń
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class=""
      style="display:flex; align-items:center; justify-content:center; gap:40px;"
    >
      <div v-if="role === 'ADMIN1' || role === 'ADMIN2'" class="form">
        <h2>Dodaj nowy kod</h2>
        <add-new-promotion @justAddedCode="addCodeToUserProfile" />
      </div>
      <div class="form">
        <h2>Przypisz istniejący kod</h2>
        <form class="topform" @submit.prevent="addNewPromotionalCode()">
          <br />
          <div
            class="input-container"
            style="display:flex; flex-direction:column; align-items:center"
          >
            <label>Kod promocyjny</label>
            <select class="form-control mb-4" v-model="chosenCode">
              <option
                :value="code.id"
                v-for="code in allPromotionalCodes"
                :key="code.code"
                >{{ code.code }}</option
              >
            </select>
          </div>
          <button
            style="width:300px;"
            class="btn btn-outline-dark"
            type="submit"
          >
            Dodaj
          </button>
        </form>
      </div>
    </div>

    <div
      v-if="this.userWhoUsedRefCodes && this.userWhoUsedRefCodes.length > 0"
      class="userRefCodeList mt-5"
    >
      <div v-if="promotions">
        <h2>Użytkownicy, którzy użyli kodu polecającego tego użytkownika</h2>
        <table class="table borderless   codeTable">
          <thead>
            <tr class="tr-table">
              <th scope="col">Data użycia kodu</th>
              <th scope="col">Numer telefonu użytkownika</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in userWhoUsedRefCodes" :key="user.id">
              <td>
                {{ user.creationDate ? formattedDate(user.creationDate) : "" }}
              </td>

              <td>{{ user.userEntity.phone }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../shared";
import AddNewPromotion from "../components/AddNewPromotion.vue";
export default {
  name: "UserPromotions",
  components: { AddNewPromotion },
  data() {
    return {
      phoneNumber: "",
      message: "",
      chosenCode: "",
    };
  },

  async created() {
    this.$store.dispatch("getAllUserPromotionalCodes", this.$attrs.id);
    await this.getUserData();
    await this.$store.dispatch("getAllCodes", true);
  },
  destroyed() {
    this.$store.dispatch("setPromotionalCodesToNull");
  },
  mounted() {
    this.formattedDate = shared.formattedDateAsNumbers;
    this.isFuture = shared.isFuture;
  },
  methods: {
    async addNewPromotionalCode() {
      const id = this.userById.user_profile.user.id;

      if (this.chosenCode) {
        const response = await this.$store.dispatch("assignCodeToUser", {
          userId: id,
          codeId: this.chosenCode,
        });
        if (response && response !== "code_already_used") {
          this.$notify({
            group: "success",
            text: "Pomyślnie przypisano kod promocyjny!",
          });
          this.$store.dispatch("getAllUserPromotionalCodes", this.$attrs.id);
          this.chosenCode = "";
        } else if (response === "code_already_used") {
          this.$notify({
            group: "error",
            text: "Ten kod został już przypisany do użytkownika.",
          });
        }
      }
    },
    async getUserData() {
      this.$store.dispatch("getUserById", {
        userId: this.$route.params.id,
      });
    },
    async addCodeToUserProfile(code) {
      const id = this.userById.user_profile.user.id;
      await this.$store.dispatch("getAllCodes", true);
      this.allPromotionalCodes.forEach(async (codeElement) => {
        if (codeElement.code === code.toUpperCase()) {
          await this.$store.dispatch("assignCodeToUser", {
            userId: id,
            codeId: codeElement.id,
          });
          this.$store.dispatch("getAllUserPromotionalCodes", this.$attrs.id);
        }
      });
    },
    async startDeletingProcess(promotion) {
      try {
        const confirmMessage = "USUŃ";
        const confirmed = prompt(
          `Czy na pewno chcesz usunąć kod promocyjny "${
            promotion.promotional_code.code
          }" z konta użytkownika ${this.userById.user_profile.profile
            .first_name +
            " " +
            this.userById.user_profile.profile
              .last_name}? Potwierdz wpisując "USUŃ"`,
          ""
        );

        if (confirmed === confirmMessage) {
          const response = await this.$store.dispatch("removeCodeFromUser", {
            userId: this.userById.user_profile.user.id,
            promotionId: promotion.id,
          });
          if (response) {
            this.$notify({
              group: "success",
              text: "Pomyślnie usunięto kod promocyjny!",
            });
            this.$store.dispatch("getAllUserPromotionalCodes", this.$attrs.id);
          } else {
            this.$notify({
              group: "error",
              text: "Nie udało się usunąć kodu promocyjnego.",
            });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
  },

  computed: {
    promotions() {
      if (this.$store.getters.getUserPromotionalCodes) {
        return this.$store.getters.getUserPromotionalCodes.promotionalCodes;
      } else {
        return [];
      }
    },
    userWhoUsedRefCodes() {
      if (this.$store.getters.getUserPromotionalCodes) {
        return this.$store.getters.getUserPromotionalCodes.usersWhoUsedRefCode;
      } else {
        return [];
      }
    },
    userById() {
      return this.$store.getters.getUserById;
    },
    allPromotionalCodes() {
      return this.$store.getters.getAllPromotionalCodes;
    },
    role() {
      return this.$store.getters.getUserRole;
    },
  },
};
</script>

<style scoped></style>
